.root {
  padding: 0.75rem 1rem;
  text-align: center;
}

.title {
  line-height: 1.125rem;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;

  width: 100%;
}

.item {
  display: flex;
  gap: 0.375rem;
  align-items: center;
}

.checkIcon {
  font-size: 1rem;
}
